import { ReplenishmentDetailPage } from "@/features/replenishment/pages/ReplenishmentDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/replenishment/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["replenishment.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ReplenishmentDetailPage,
});
